import React from 'react';
import styled from 'styled-components';
import { Container, Section, H3Text1 } from './Content.style';
import ImgDescCard from 'components/ImgDescCard';
import { H2Text, NormalSpan } from 'pages/charterQuote/components/contents/Content.style';

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #dde2e4;
  flex-direction: column;
  gap: 48px;
  margin-bottom: 40px;
`;

const HeaderDesc = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

const Desc = styled(NormalSpan)`
  color: #424748;
`;

const DescBox = styled.div`
  display: flex;
  gap: 24px;
  justify-content: space-between;
  align-items: center;
  img {
    width: 32px;
  }
`;

const Title = styled(H3Text1)`
  width: 100%;
  padding: 24px 16px;
  border-bottom: 1px solid #dde2e4;

  &:first-child {
    padding: 24px 8px;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Header = () => {
  return (
    <HeaderContainer>
      <H2Text>
        Our Commitment to <br />
        Convenience and <br />
        Affordability
      </H2Text>
      <HeaderDesc>
        <DescBox>
          <img
            src="/imgs/svg/charterQuote/convenience.svg"
            alt="Our Commitment to Convenience and Affordability"
          />
          <Desc>
            We’re dedicated to convenience and affordability, making private jet travel accessible.
            Our easy-to-use platform lets you quickly request a private plane quote, choose your
            aircraft, and book your flight with just a few clicks.
          </Desc>
        </DescBox>
        <DescBox>
          <img
            src="/imgs/svg/charterQuote/stars.svg"
            alt="estimated private jet charter costs for your charter flight"
          />
          <Desc>
            We offer flexible options that cater to various budgets and flight requirements, helping
            you plan a stress-free and cost-effective journey. Whether it's a last-minute business
            trip or a luxurious getaway, we make private travel more accessible than ever.
          </Desc>
        </DescBox>
      </HeaderDesc>
    </HeaderContainer>
  );
};

const SafetyExpertise = () => {
  return (
    <Container>
      <Section>
        <Header />

        <ImgDescCard
          isLeft
          imgSrc="/imgs/webp/charterQuote/safety.webp"
          imgAlt="close up of turbine on a private jet on a cloudy day"
          title="Safety and Expertise"
          desc={[
            'Your safety is our top priority, which is why we partner with only the most trusted and certified operators in the industry.',
            'Our pilots are highly trained and experienced, and we follow strict safety protocols to ensure secure flights. Airacer works with fully vetted operators to guarantee that each flight meets the highest safety, reliability, and professionalism standards, giving you peace of mind every time you fly with us.',
          ]}
        >
          <TitleBox>
            <Title>
              We require each operator to provide the following information and documentation before
              each flight
            </Title>
            <Title>Pre-flight safety checks</Title>
            <Title>Pilot and Crew vetting</Title>
            <Title>Up-to-date maintenance records</Title>
            <Title>Updated safety and insurance policies</Title>
          </TitleBox>
        </ImgDescCard>
      </Section>
    </Container>
  );
};

export default SafetyExpertise;
